import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("3aqarate_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Une erreur est survenue";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const CURRENCY_SYMBOLS = { MAD: "MAD", DZD: "DA", TND: "DT" };
export const COUNTRY_LABELS = { MA: "Maroc", DZ: "Algérie", TN: "Tunisie" };
export const COUNTRY_FLAGS = { MA: "🇲🇦", DZ: "🇩🇿", TN: "🇹🇳" };

export function formatPrice(price, currency, type) {
  const symbol = CURRENCY_SYMBOLS[currency] || currency;
  const formatted = new Intl.NumberFormat("fr-FR").format(Math.round(price));
  const suffix = type === "location" ? "/mois" : "";
  return `${formatted} ${symbol}${suffix}`;
}

export const CITIES_BY_COUNTRY = {
  MA: ["Casablanca", "Marrakech", "Rabat", "Tanger", "Fès", "Agadir", "Meknès", "Oujda"],
  DZ: ["Alger", "Oran", "Constantine", "Annaba", "Blida", "Tlemcen", "Sétif"],
  TN: ["Tunis", "Sousse", "Sfax", "Hammamet", "Bizerte", "Monastir", "Djerba"],
};

export const PROPERTY_TYPES = [
  { value: "appartement", label: "Appartement" },
  { value: "villa", label: "Villa" },
  { value: "riad", label: "Riad" },
  { value: "maison", label: "Maison" },
  { value: "terrain", label: "Terrain" },
  { value: "bureau", label: "Bureau" },
  { value: "local", label: "Local commercial" },
];

export const AMENITIES_LIST = [
  "Ascenseur", "Parking", "Garage", "Piscine", "Jardin", "Terrasse",
  "Balcon", "Climatisation", "Chauffage", "Cuisine équipée", "Vue mer",
  "Sécurité 24/7", "Wifi", "Hammam", "Cave", "Rooftop", "Domotique",
];
